// extracted by mini-css-extract-plugin
export default {"price":"C7-z","priceRow":"D7-z","onSale":"E7-z","msrpLabelPrice":"F7-z","msrpLabel":"G7-z","originalPrice":"H7-z","percentOff":"I7-z"};